<template>
  <div class="animated fadeIn transferencias-premios-imputacion">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <div slot="header">Imputaciones de Transferencias - Saldos</div>

            <b-form-group
              label="Importe Transferencias"
              label-for="importeTransferencias"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="importeTransferencias"
                :value="importeTransferencias | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Importe Imputado"
              label-for="importeImputaciones"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="importeImputaciones"
                :value="importeImputaciones | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Saldo a Imputar" 
              label-for="saldoImputar"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="saldoImputar"
                :value="saldoImputar | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-card>

          <b-card>
            <div slot="header">Información de la Imputación</div>
            <!-- <div class="grupo-controles search-presupuestos-internos">
              <b-form-group
                label="Nro. Presupuesto:"
                label-for="numero"
                :label-cols="labelCols"
                horizontal
                description="Ingrese el número de presupuesto y adicional a seleccionar y haga click en el botón de búsqueda">
                <b-input-group>
                  <b-form-input 
                    id="numero"
                    class="number-input"
                    v-model.number="numero" 
                    type="number"
                    :state="presupuestoInternoValido"
                    @focus="$event.target.select()"/>

                  <b-input-group-append>
                    <b-input-group-text>
                      /
                    </b-input-group-text>
                  </b-input-group-append>

                  <b-form-input 
                    id="adicionalNumero"
                    class="number-input"
                    v-model.number="adicionalNumero" 
                    type="number"
                    :state="presupuestoInternoValido"
                    @focus="$event.target.select()"/>

                  <b-input-group-append 
                      class="filter-search-icons" 
                      @click="getPresupuestoInterno">
                    <b-input-group-text>
                      <i class="fa fa-search"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                  <b-form-invalid-feedback id="presupuestoInternoFeedback">
                    {{ presupuestoInternoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-input-group>
              </b-form-group>
            </div>

            <br>

            <b-form-group
              label="Cliente:"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="cliente" 
                readonly
                type="text"/>
            </b-form-group>

            <b-form-group
              label="Acción:"
              label-for="accion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="accion"
                :value="accion" 
                readonly
                type="text"/>
            </b-form-group>

            <app-orden-trabajo
              label="Orden"
              :nombre="ordenTrabajo"
              :lista="ordenesList"
              :valido="ordenTrabajoValida"
              :msjInvalido="ordenTrabajoInvalidaMsj"
              :labelCols="labelCols"
              labelOption="Seleccione una orden"
              @updated="ordenActualizada">
            </app-orden-trabajo>   -->

            <b-form-group
              label="Nro.Presupuesto"
              label-for="presupuestoNumero"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-form-input 
                  id="presupuestoNumero"
                  :value="presupuestoNumero"
                  readonly
                  type="text"/>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarPresupuestoInterno">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': presupuestoInternoId == 0,
                                  'fa fa-remove': presupuestoInternoId != 0  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="cliente"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Acción"
              label-for="accion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="accion"
                :value="accion"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Orden"
              label-for="ordenTrabajo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="ordenTrabajo"
                :value="ordenTrabajo"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Imputación"
              label-for="fechaImputacion"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaImputacion" 
                v-model="fechaImputacion" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Importe"
              label-for="importe"
              :label-cols="labelCols"
              description="Importe a imputar"
              horizontal>
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model" 
                :state="importeValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="6"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="searchPresupuestoInternoModal" 
        title="Seleccionar Presupuesto Interno"
        header-bg-variant="light" 
        hide-footer
        lazy
        modal-class="modalABM modalSearchPresupuesto">
      <app-search-presupuesto
        :soloPresupuestosAbiertos="true"
        :seleccionarSubtrabajo="false"
        :logistica="false"
        @presupuestoInternoSeleccionado="presupuestoInternoSeleccionado"
        @cancelaSeleccionPresupuestoInterno="cancelaSeleccionPresupuestoInterno">
      </app-search-presupuesto>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchPresupuesto from '../presupuestosinternos/Search.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, decimal, minValue, maxValue, numeric, maxLength } from 'vuelidate/lib/validators';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'transferenciasPremiosImputacion/getField',
  mutationType: 'transferenciasPremiosImputacion/updateField',
});

export default {
  name: 'TransferenciasPremiosImputacionABM',
  components: {
    appSearchPresupuesto: SearchPresupuesto,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      presupuestoInternoValido: null,
      presupuestoInternoInvalidoMsj: '',
      ordenTrabajoValida: null,
      ordenTrabajoInvalidaMsj: '',
      importeValido: null,
      importeInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      numero: 0,
      adicionalNumero: 0,
      ordenesList: [],

      tableBusy: false,
      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'fechaImputacion',
      'presupuestoInternoId',
      'presupuestoNumero',
      'cliente',
      'accion',
      'ordenTrabajoId',
      'ordenTrabajo',
      'importe',
      'observaciones',

      'importeTransferencias',
      'importeImputaciones',
      'saldoImputar'
    ]),
  },
  created() {
    this.$store.dispatch('transferenciasPremiosImputacion/inicializar');
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importe' || validarTodos) {
        this.importeValido = null;
        this.importeInvalidoMsj = this.displayErrorMonto (this.$v.importe.$error, 
          this.$v.importe.decimal, this.$v.importe.minValue); 
        
        if (this.importeInvalidoMsj.trim() != '') {
          this.importeValido = false;
        }
      }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    displayErrorMonto( fieldError, fieldErrorDecimal, fieldErrorMinValue) {
      let errorMsj = '';
      if (fieldError) {
        if (fieldErrorDecimal) {
          errorMsj = 'El monto ingresado debe ser un valor numérico';
        } else if (fieldErrorMinValue) {
          errorMsj = 'El monto ingresado no es válido';
        }
      }
      return errorMsj;
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      let presupuestoInternoError = true;
      if (this.presupuestoInternoId) {
        if (this.presupuestoInternoId != 0) {
          presupuestoInternoError = false;
        }
      }
      if (presupuestoInternoError) {
        save = Boolean(false);
        this.presupuestoInternoValido = false;
        this.presupuestoInternoInvalidoMsj = "Debe seleccionar el presupuesto interno correspondiente.";
      }

      let ordenTrabajoError = true;
      if (this.ordenTrabajoId) {
        if (this.ordenTrabajoId != 0) {
          ordenTrabajoError = false;
        }
      }
      if (ordenTrabajoError) {
        save = Boolean(false);
        this.ordenTrabajoValida = false;
        this.ordenTrabajoInvalidaMsj = "Debe seleccionar la orden de trabajo correspondiente.";
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('transferenciasPremiosImputacion/save')
            .then( () => this.showModalMsj ('El movimiento se registró con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$router.push({ name: 'TransferenciasPremiosImputaciones' });
    },

    seleccionarPresupuestoInterno() {
      if (this.presupuestoInternoId != 0) {
        let params = {
          presupuestoInterno: null,
          ordenTrabajo: null,
        }
        this.$store.dispatch('transferenciasPremiosImputacion/setPresupuestoInterno', params)
          .catch(error => this.showErrorMsj(error));
      } else {
        this.$refs.searchPresupuestoInternoModal.show()
      }
    },
    presupuestoInternoSeleccionado(params) {
      this.$refs.searchPresupuestoInternoModal.hide();
      this.$store.dispatch('transferenciasPremiosImputacion/setPresupuestoInterno', params)
        .catch(error => this.showErrorMsj(error));
    },
    cancelaSeleccionPresupuestoInterno() {
      this.$refs.searchPresupuestoInternoModal.hide()
    },

    // getPresupuestoInterno() {
    //   this.presupuestoInternoValido = null;
    //   this.presupuestoInternoInvalidoMsj = '';

    //   let numero = 0;
    //   if (this.numero) {
    //     if (!isNaN(this.numero)) {
    //       numero = parseInt(this.numero);
    //     }
    //   }
    //   let adicionalNumero = -1;
    //   if (this.adicionalNumero) {
    //     if (!isNaN(this.adicionalNumero)) {
    //       adicionalNumero = parseInt(this.adicionalNumero);
    //     }
    //   }

    //   if (numero != 0) {
    //     let params = {
    //       numero,
    //       adicionalNumero,
    //       clienteId: 0,
    //       logistica: false,
    //       loadOrdenes: true
    //     }

    //     this.showSpinner();
    //     this.$store.dispatch('transferenciasPremiosImputacion/inicializarPresupuestoInterno')
    //       .then(() =>  {
    //         return this.$store.dispatch('presupuestointerno/searchPresupuesto', params)
    //       })
    //       .then(() => {
    //         this.ordenesList = this.$store.getters['presupuestointerno/ordenesListSearch'];

    //         return this.$store.dispatch('transferenciasPremiosImputacion/setPresupuestoInterno', 
    //           this.$store.getters['presupuestointerno/presupuestoSearch']);
    //       })
    //       .catch(error => this.showErrorMsj(error, 'danger'))
    //       .finally(() => this.hideSpinner())
    //   } else {
    //     this.showErrorMsj('Verifique el número de presupuesto ingresado', 'danger');
    //   }
    // },
    // ordenActualizada(ordenNombre) {
    //   console.log(ordenNombre);
    //   console.log(this.ordenesList);

    //   let ordenTrabajo = null;
    //   if (ordenNombre) {
    //     this.ordenesList.forEach(t => {
    //       if (t.id.toString().trim() + ' - ' + t.titulo.trim() == ordenNombre.trim()) {
    //         ordenTrabajo = t;
    //       }
    //     })
    //   }
    //   console.log(ordenTrabajo)
    //   this.$store.dispatch('transferenciasPremiosImputacion/setOrdenTrabajo', ordenTrabajo);

    //   this.ordenTrabajoValida = null;
    //   this.ordenTrabajoInvalidaMsj = '';
    // },
  },
  validations: {
    importe: { decimal, minValue: minValue(0) },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
}
</script>

<style>
</style>
